<div class="under-development-actions" aria-label="Page actions">
  <button
    pButton
    type="button"
    class="p-button under-development-button under-development-button-primary"
    (click)="homeRequested.emit()">
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M19 12H5" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
      <path d="M12 19l-7-7 7-7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
    <span>Back to home</span>
  </button>

  <button
    pButton
    type="button"
    class="p-button-outlined under-development-button under-development-button-secondary"
    (click)="refreshRequested.emit()">
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M20 11a8 8 0 0 0-14.9-4" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
      <path d="M5 3v4h4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M4 13a8 8 0 0 0 14.9 4" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
      <path d="M19 21v-4h-4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
    <span>Refresh</span>
  </button>
</div>
